// Утилита для предзагрузки и кеширования изображений в памяти

const IMAGE_CACHE = new Map<string, HTMLImageElement>();

// Список всех фоновых изображений для виджетов и страниц
export const BACKGROUND_IMAGES = [
  "/assets/ambient.webp",
  "/assets/ambient-radial.webp",
  "/assets/sheet-bg.png",
  "/assets/bottom-bg.png",
] as const;

/**
 * Предзагружает изображение и сохраняет его в кеше
 */
function preloadImage(src: string): Promise<HTMLImageElement> {
  // Если изображение уже в кеше, возвращаем его
  if (IMAGE_CACHE.has(src)) {
    return Promise.resolve(IMAGE_CACHE.get(src)!);
  }

  return new Promise((resolve, reject) => {
    const img = new Image();
    
    img.onload = () => {
      IMAGE_CACHE.set(src, img);
      resolve(img);
    };
    
    img.onerror = () => {
      reject(new Error(`Failed to load image: ${src}`));
    };
    
    img.src = src;
  });
}

/**
 * Предзагружает все фоновые изображения
 */
export function preloadBackgroundImages(): Promise<void> {
  return Promise.allSettled(
    BACKGROUND_IMAGES.map(src => preloadImage(src))
  ).then(() => {
    console.log("[ImagePreloader] Background images preloaded and cached");
  });
}

/**
 * Получает предзагруженное изображение из кеша
 */
export function getCachedImage(src: string): HTMLImageElement | null {
  return IMAGE_CACHE.get(src) || null;
}

/**
 * Проверяет, загружено ли изображение
 */
export function isImageCached(src: string): boolean {
  return IMAGE_CACHE.has(src);
}
